"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDatocms = require("react-datocms");

var _Sizer = _interopRequireDefault(require("./components/Sizer"));

var _excluded = ["image", "width", "height", "classes", "layout", "component", "aspectRatio", "pictureStyle", "alt", "title", "style"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DATOCMS_LAYOUT = {
  fixed: 'fixed',
  full: 'fill',
  fluid: 'intrinsic',
  responsive: 'responsive',
  background: 'fill'
};
var Picture = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref2;

  var image = _ref.image,
      width = _ref.width,
      height = _ref.height,
      classes = _ref.classes,
      layout = _ref.layout,
      _ref$component = _ref.component,
      Wrapper = _ref$component === void 0 ? 'div' : _ref$component,
      aspectRatio = _ref.aspectRatio,
      pictureStyle = _ref.pictureStyle,
      alt = _ref.alt,
      title = _ref.title,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(width || 0),
      _useState2 = _slicedToArray(_useState, 2),
      thisWidth = _useState2[0],
      setThisWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(height || 0),
      _useState4 = _slicedToArray(_useState3, 2),
      thisHeight = _useState4[0],
      setThisHeight = _useState4[1];

  var _useState5 = (0, _react.useState)((_ref2 = aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : height && width ? width / height : undefined) !== null && _ref2 !== void 0 ? _ref2 : 1),
      _useState6 = _slicedToArray(_useState5, 2),
      thisAspectRatio = _useState6[0],
      setThisAspectRatio = _useState6[1];

  (0, _react.useEffect)(function () {
    if (aspectRatio || width && height || typeof image !== 'string' || image.indexOf('http') === -1) {
      return;
    }

    var img = new Image();

    img.onload = function () {
      setThisWidth(this.width);
      setThisHeight(this.height);
      setThisAspectRatio(this.width / this.height);
    };

    img.src = image;
  }, [width, height, image, aspectRatio, setThisAspectRatio, setThisWidth, setThisHeight]);
  var thisImage = (0, _react.useMemo)(function () {
    if (typeof image === 'string') {
      return image;
    }

    if (_typeof(image) === 'object') {
      if (image !== null && image !== void 0 && image.file) {
        return image.file;
      }

      return image;
    }

    return null;
  }, [image]);

  if (thisImage) {
    var _DATOCMS_LAYOUT;

    var thisLayout = (_DATOCMS_LAYOUT = DATOCMS_LAYOUT === null || DATOCMS_LAYOUT === void 0 ? void 0 : DATOCMS_LAYOUT[layout]) !== null && _DATOCMS_LAYOUT !== void 0 ? _DATOCMS_LAYOUT : 'intrinsic';

    var wrapperStyle = _objectSpread(_objectSpread(_objectSpread({}, layout === 'background' && {
      position: 'absolute',
      inset: 0
    }), layout === 'full' && {
      position: 'relative'
    }), style);

    var datoCMSImageStyle = _objectSpread(_objectSpread({}, layout === 'fixed' && {
      height: thisHeight,
      width: thisWidth
    }), pictureStyle);

    var data = _objectSpread({
      aspectRatio: thisAspectRatio,
      base64: undefined,
      height: thisHeight,
      width: thisWidth,
      sizes: undefined,
      srcSet: undefined,
      webpSrcSet: undefined,
      bgColor: undefined,
      alt: alt,
      title: title,
      src: typeof thisImage === 'string' ? thisImage : undefined
    }, _typeof(thisImage) === 'object' && thisImage);

    return /*#__PURE__*/_react["default"].createElement(Wrapper, {
      "data-picture-wrapper": true,
      className: classes === null || classes === void 0 ? void 0 : classes.wrapper,
      style: wrapperStyle
    }, /*#__PURE__*/_react["default"].createElement(_Sizer["default"], {
      layout: layout,
      aspectRatio: thisAspectRatio
    }), /*#__PURE__*/_react["default"].createElement(_reactDatocms.Image, _extends({
      data: data,
      ref: ref,
      pictureClassName: classes === null || classes === void 0 ? void 0 : classes.picture,
      pictureStyle: datoCMSImageStyle,
      layout: thisLayout
    }, props)));
  }

  return null;
});
var _default = Picture;
exports["default"] = _default;